import React, { useState, useEffect } from "react";
import DataMap from "./dataMap";
import DataTotal from "./dataTotal";
import Style from "./index.module.css"
const IndexMap = () => {
  return (
    <div className={Style.wrap}>
      {/* <h1 style={{textAlign:'center',marginTop:30,color:"#fff",fontWeight:'bold'}}>贵州省民间文艺作品版权资源数据库</h1> */}
      <div style={{ display: "flex", justifyContent: 'center' }}>
        <div className={Style.map}>
          <DataMap />
        </div>
        <div className={Style.mapCount}>
          <DataTotal />
        </div>
   
      </div>
    </div>
  );
};

export default IndexMap;
